const ServiceSkeleton = () => {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 mt-10">
      {[...Array(6)].map((_, idx) => (
        <div
          key={idx}
          className="bg-white shadow-md rounded-lg overflow-hidden animate-pulse"
        >
          <div className="w-full h-52 bg-gray-300"></div>

          <div className="p-4">
            <div className="flex justify-between items-center mb-2">
              <div className="w-24 h-6 bg-gray-300 rounded"></div>
            </div>

            <div className="h-6 bg-gray-300 rounded w-3/4 mb-2"></div>
            <div className="h-14 bg-gray-300 rounded w-full mb-4"></div>

            <div className="mt-4 w-full h-10 bg-gray-300 rounded-lg"></div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ServiceSkeleton;
